export const ERROR_EFE_LIST = 'movilidad/ventaperdida/error-olas-list';
export const RECEIVE_EFE_LIST = 'movilidad/ventaperdida/receive-reportefectividad-list';
export const REQUEST_OLAS_LIST = 'movilidad/ventaperdida/request-reportefectividad-list';
export const RESTART_STATE = 'movilidad/ventaperdida/restart_state';
export const SET_MASK = 'movilidad/ventaperdida/set-mask';
export const SET_ORDER = 'movilidad/ventaperdida/set-order';
export const SET_SELECTED_ROW = 'movilidad/ventaperdida/set-selected-row';
export const UPDATE_FIELD_FILTER = 'movilidad/ventaperdida/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'movilidad/ventaperdida/set-selected-row';